// extracted by mini-css-extract-plugin
var _1 = "alert-bar--x9_e1";
export { _1 as "alert-bar" }
